import React from 'react';

export const CustomPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  
  const style = {
    padding: `${commonAttrs.paddingTop}px ${commonAttrs.paddingRight}px ${commonAttrs.paddingBottom}px ${commonAttrs.paddingLeft}px`,
    margin: `${commonAttrs.marginTop}px ${commonAttrs.marginRight}px ${commonAttrs.marginBottom}px ${commonAttrs.marginLeft}px`,
    border: isSelected ? '2px solid #3B82F6' : '2px dashed #D1D5DB',
    borderRadius: '8px',
    padding: '24px',
    cursor: 'pointer',
    textAlign: 'center',
    backgroundColor: '#F9FAFB'
  };

  return (
    <div style={style} onClick={onClick}>
      <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>
        {specificAttrs.componentName || 'Custom Component'}
      </div>
      <div style={{ fontSize: '12px', color: '#6B7280' }}>
        {specificAttrs.description || 'Custom component configuration'}
      </div>
    </div>
  );
};
